import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useGetLoggedUser } from "../../shared/hooks/useUser";

const LoginProtected = ({ children }) => {
    const { data: loggedUser, status } = useGetLoggedUser(true);

    const [loggedIn, setLoggedIn] = useState();

    useEffect(() => {
        if (loggedUser && loggedUser.user_type) {
            if (loggedUser.user_type !== "Website User") {
                // navigate("/tables")
                setLoggedIn(true);
            } else {
                setLoggedIn(false);
            }
        }
    }, [loggedUser]);

    if (loggedIn) {
        const isKitchen = loggedUser?.role_profile_name === "Kitchen";
        return <Navigate to={isKitchen ? "/kds/Kitchen" : "/tables"} replace />;
    }
    return children;
};

export default LoginProtected;
